<template>
<div class="container" :class="{loadingItem: isProductLoading}">
  <div v-if="isProductLoading" class="row text-center">
    <grid-loader :loading="isProductLoading" :color="loaderColor" :size="loaderSize"></grid-loader>
  </div>
  <div v-else class="row action-panel align-items-center">
    <div class="col-3 col-sm-4">
      <div v-if="itemLevel==1" class="font-weight-bold">
        Product Categories
      </div>
      <div v-else>
        <button class="btn btn-dark" @click="setShowItemLevel(1)">
          <i class="fa fa-angle-left d-inline"></i> Back
        </button>
      </div>
    </div>
    <div class="col-6 col-sm-4 text-center font-weight-bold">
      <span v-if="itemLevel==2 && curItem1Name" class="font-weight-bold">{{ curItem1Name }}</span>
    </div>
    <div class="col-3 col-sm-4">
      <div class="btn-group btn-group-sm pull-right">
				<button id="list" class="btn btn-outline-dark" @click.prevent="changeDisplay(true)">
          <i class="fa fa-list" aria-hidden="true"></i> List
				</button>
				<button id="grid" class="btn btn-outline-dark" @click.prevent="changeDisplay(false)">
          <i class="fa fa-th" aria-hidden="true"></i> Grid
				</button>
      </div>
    </div>
  </div>

  <div class="row" v-if="!isProductLoading && itemLevel==1">
      <app-product-item1 v-for="item1 in items1" :item="item1" :key="item1.nbr" :displayList="displayList"></app-product-item1>
  </div>
  <div class="row" v-else-if="!isProductLoading && itemLevel==2">
    <app-product-item2 v-for="item2 in items2" :item="item2" :key="item2.nbr" :displayList="displayList"></app-product-item2>
  </div>


</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex';
import ProductItem1 from './product/ProductItem1.vue';
import ProductItem2 from './product/ProductItem2.vue';
import GridLoader from 'vue-spinner/src/GridLoader.vue';

export default {
  data() {
    return {
      loaderColor: "#5cb85c",
      loaderSize: "50px",
      displayList: true,
    }
  },
  computed: {
    ...mapGetters(['items1', 'items2', 'curItem1Name', 'isProductLoading', 'itemLevel']),
  },
  components: {
    appProductItem1: ProductItem1,
    appProductItem2: ProductItem2,
    GridLoader
  },

  created() {
    let details = navigator.userAgent;
      
      /* Creating a regular expression
      containing some mobile devices keywords
      to search it in details string*/
      let regexp = /android|iphone|kindle|ipad/i;
      
      /* Using test() method to search regexp in details
      it returns boolean value*/
      let isMobileDevice = regexp.test(details);
      
      if (isMobileDevice) {
        this.displayList = true
      } else {
        this.displayList = false
      }
  },

  methods: {
    ...mapActions(['setItemLevel', 'setOrgId']),

    setShowItemLevel(itemLevel) {
      this.setItemLevel({itemLevel})
    },

    changeDisplay(isList) {
      this.displayList = isList;
    }
  }
}
</script>

<style>
.loadingItem {
  align-items: center;
  justify-content: center;
  display: flex;
}

.action-panel {
  margin-bottom: 10px;
  margin-right: 5px;
}
</style>
